<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="12" md="6">
      <v-row>
       <v-col cols="12" sm="12" md="12">
           <v-img class="mx-auto" :src="damnnogo" contain aspect-ratio="1.5" position="center" max-width="150"></v-img>
            </v-col>
       <!--
          <v-col cols="12" sm="12" md="12" style="margin-top:-40px;">
           <v-img class="mx-auto" :src="logo" contain aspect-ratio="1.5" position="center" max-width="350"></v-img>
            </v-col> -->
        </v-row>  
       
        <v-card class="elevation-12">
          <template>
  <v-card color="basil">
  <!--  <v-card-title class="text-center justify-center py-6">
      <h1 class="font-weight-bold text-h2 basil--text">
        BASiL
      </h1>
    </v-card-title> -->
<v-tabs
 v-model="tab"
         background-color="white"
      color="basil"
      grow
>
<v-tab @click="tabselect('login')" href="#login">
    Login
  </v-tab>
  <v-tab-item value="login">
     <span class="pl-5" v-if="error"><strong class=" red--text">{{errorText}}</strong></span>
     
  <v-form action="#" @submit.prevent="login">
             <v-card-text>
              <v-text-field
                label="Username"
                name="username"
                prepend-icon="person"
                type="text"
                id="username"
                :rules="loginusernameRule"
                v-model="loginusername"
              />
              <v-text-field
                id="password"
                label="Password"
                name="password"
                prepend-icon="lock"
                type="password"
                :rules="loginpasswordRule"
                v-model="loginpassword"
              />

          <!--      <v-text-field
                id="damnnid"
                label="DamnN ID"
                name="dammNId"
                prepend-icon="key"
                type="text"
                :rules="logindamnnidRule"
                v-model="loginDamnnId"
              />
              -->
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn type="submit" color="primary">Login</v-btn>
              <v-spacer />
            </v-card-actions>
            <!--
            <v-row>
                <v-col col="12">
                  <hr>
                <iframe id='a543742c' name='a543742c' src='https://ads.damnn.com.au/www/delivery/afr.php?zoneid=40&amp;cb=INSERT_RANDOM_NUMBER_HERE' frameborder='0' scrolling='no' width='300' height='250' allow='autoplay'><a href='https://ads.damnn.com.au/www/delivery/ck.php?n=a327ea5c&amp;cb=INSERT_RANDOM_NUMBER_HERE' target='_blank'><img src='https://ads.damnn.com.au/www/delivery/avw.php?zoneid=40&amp;cb=INSERT_RANDOM_NUMBER_HERE&amp;n=a327ea5c' border='0' alt='' /></a></iframe>
                </v-col>    
              </v-row>   -->
          </v-form>
  </v-tab-item>
  <v-tab @click="tabselect('signup')" href="#signup">
   Sign Up
  </v-tab>
  <v-tab-item value="signup">
      <span class="pl-5" v-if="error"><strong class=" red--text">{{errorText}}</strong></span>
     
  <v-form @submit.prevent="validate" ref="form" lazy-validation>
            <v-card-text>
              <v-row>
                <v-col>
          <template>
              <p class="text-justify">
                This sign up page is for DamnN International so although you are signing up for QuizStar or DROAD or Sportstrade it is all DamnN International.
              </p>
              <p class="text-justify">
                After you have filled out this form you will  receive a personal DamnN International number that will be sent to your email.
              </p>   
              <p class="text-justify"> 
                All the information is important because there will be opportunities that arise that will be in certain locations and areas to win rewards.
              </p>   
             </template> 
            </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-text-field v-model="firstname" label="Name"></v-text-field>
                </v-col>
            
                <v-col cols="6">
                  <v-text-field v-model="username" :rules="usernameRule" label="Username" required></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col >
                  <v-text-field v-model="email" :rules="emailRules" label="E-mail" required></v-text-field>
                </v-col>
               
              </v-row>
              <v-row>
                 <v-col cols="6">
                 
                  <date-pick class="dobpicker"  :format="'DD/MM/YYYY'" v-model="dob">
                        <template v-slot:default="{toggle}">
                       <v-text-field  hide-details   label="DOB" @click="toggle" v-on:keyup="formatdate($event)" placeholder="DD/MM/YYYY" v-model="dob"></v-text-field>
                      </template>
                      </date-pick>
                </v-col>
                 <v-col cols="6">
                  <v-select v-model="gender"  :items="genderarr" label="Gender" required></v-select>
              
                 </v-col> 
              </v-row>  
             <v-row>
                <v-col cols="6">
                
                   <v-text-field
            v-model="password"
            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="passwordRule"
            :type="show1 ? 'text' : 'password'"
            name="input-10-1"
            label="Password"
            hint="At least 6 characters"
            counter
            @click:append="show1 = !show1"
          ></v-text-field>
                </v-col>
             
                <v-col cols="6">
                <v-text-field
                        v-model="confirmpassword"
                        :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="confirmpasswordRule"
                        :type="show2 ? 'text' : 'password'"
                        name="input-10-1"
                        label="Confirm Password"
                        hint="At least 6 characters"
                        counter
                        @click:append="show2 = !show2"
          ></v-text-field>   </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-select v-model="region" :rules="regionRule" @change="stateslist($event)" :items="regions" label="Country" required></v-select>
                </v-col>
             
                <v-col cols="6">
                   <v-autocomplete id="stateid" :rules="stateidRule" @change="selectcities($event)"  v-model="stateid" :items="statesarr" item-text="state_name" item-value="state_id"   dense
                       filled label="State / County"  class="p-0" ></v-autocomplete>
                </v-col>
              </v-row>
               <v-row>
                <v-col cols="6">
                  <v-autocomplete id="city" :rules="cityRule" v-model="cityname" :items="cities" item-text="city_name" item-value="city_id"   dense
                       filled label="City"  class="p-0" ></v-autocomplete>
                  <!--<v-text-field v-model="cityname" label="City" required></v-text-field> -->
                </v-col>
             
                <v-col cols="6">
                  <v-text-field v-model="suburb" label="Suburb" required></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn type="submit" color="primary">Create Account</v-btn>
              <v-spacer />
            </v-card-actions>
         
          </v-form>
  </v-tab-item>

</v-tabs>
<!--
          <v-row justify="start"> 
                    <v-col v-for="(getwebsite) in websitelist" :key="getwebsite.publisherId" class="text-left mr-0" cols="2" sm="2" md="2"> 
                      <v-avatar  :style="{ 'background-color': getwebsite.websitecolor }" size="100%"  >
                                     <img style="width:100%;height:100%;" :src="adserverURL+'images/'+getwebsite.websitelogo">    
                         </v-avatar>
                      </v-col>
                  </v-row> -->

                  <template>
  <v-container>
    
    <v-row justify="left">
      <v-col cols="12">
        <h4>Advertise Ads. Here </h4>
        <hr>
      </v-col>  
      <v-row justify="left"> 
      <v-col
        v-for="(getwebsite) in websitelist" 
        :key="getwebsite.publisherId"
        cols="3"
      >
        <v-card
          height="100"
          width="100"
          class="elevation-12"
        >
         <v-sheet  class="pt-4 pl-1 pr-1 rounnded-lg sheetborder" color="white  lighten-2" >
            <img style="width:100%;height:100%;" :src="adserverURL+'images/'+getwebsite.websitelogo">    
            </v-sheet> 
        </v-card>
      </v-col>
       </v-row>
    </v-row>
  </v-container>
</template>
  </v-card>
</template>
         
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DatePick from 'vue-date-pick';
import 'vue-date-pick/dist/vueDatePick.css';
export default {
  name: "Register",
  components: {DatePick},
  data() {
    return {
     // logo: require("@/assets/logo-1.png"),
      damnnogo: require("@/assets/damnnlogo2.png"),
      region: "",
      regions: [],
      firstname: "",
      lastname: "",
      email: "",
      username : "",
      password: "",
      gender:"",
      city:"", 
      stateid:"",
      cityname:"",
      suburb:"",
       statesarr:[],
      confirmpassword:"", 
      dob:"",
        from_date: "",
      fromdate: "2022-03-09",
      cities:[],
       show1: false,
       show2 : false,  
      loginusername : "",
      loginpassword : "",
      loginDamnnId : "",
      emailRules: [
        v => !!v || "Please enter your email address",
        v =>
          /.+@.+\..+/.test(v) ||
          "This doesn't appear to be a valid email address"
      ],
      passwordRule: [
        v => v.length >= 6 || "Password must be at least 6 characters"
      ],
      confirmpasswordRule: [
        v => v.length >= 6 || "Confirm Password must be at least 6 characters",
         v =>
          v === this.password || 'The password confirmation does not match.',
      ],
      regionRule: [
        v => !!v || "Select the most accurate locale so we can provide you with more relevant questions"
      ],
       cityRule: [
        v => !!v || "Please Select the city."
      ],
      stateidRule: [
        v => !!v || "Please Select the state."
      ],
       usernameRule: [
        v => !!v || "Please enter your username."
      ],
      genderarr:["Male","Female","Other"],
      loginusernameRule: [
        v => !!v || "Please enter username"
      ],
      loginpasswordRule: [
        v => !!v || "Please enter password"
      ],
      logindamnnidRule: [
        v => !!v || "Please enter DamnnId"
      ],
      tab: null,
      error:false,
      errorText:"",
      videodisplay:false,
      websitelist:[],
      adserverURL : process.env.VUE_APP_ADSERVER_WEB_BASEURL,
    };
  },
  mounted(){
    this.getRegions();
    this.getAdserverWebsiteList();
  },
  methods: {
     formatdate(event){
      var delimeter = "/";
       if(event.code != "Backspace")
       {
         if(this.dob.length == 2 || this.dob.length == 5)
         {
           this.dob = this.dob + delimeter;
         }
       }
       else
       {
          if(event.code == "Backspace")   
          {
             if(this.dob.length == 2)
            {
              this.dob = '';
            }
          } 
       }
    },
     login() { 
      if(this.loginusername === '' || this.loginpassword === ''/* || this.loginDamnnId === ''*/)
      {
        this.error = true;
        this.errorText = "Please enter your login credentials";
        return 
      } 
      this.$store
        .dispatch("retrieveToken", {
          username: this.loginusername,
          password: this.loginpassword,
          DamnnId: this.loginDamnnId, 
        })
        .then(() => {
          this.$store
            .dispatch("retrieveUserDetails")
            .then(() => {
              this.$router.push({ name: "home" });
            })
        })
        .catch(error => {
          this.error = true;
          console.log(error);
          this.errorText = "Invalid credentials. Please try again.";
          // this.errorText = error.response.data.message.response.message;
           //alert(error);
        });
    },
    tabselect(gettab){

        switch(gettab)
        {
          case "login":
            this.resetlogin_form();
          break;
          case "signup":
            this.resetsignup_form(); 
          break;    
          case "videoshow":
            this.videodisplay = true;
          break;  
        }

    },
    resetlogin_form()
    {
           this.loginusername = "";
           this.loginpassword = "";
           this.loginDamnnId = "";
    },
     resetsignup_form()
    {
           this.firstname = "";
           this.email = "";
           this.password = "";
            this.confirmpassword = "";
           this.region = "";
           this.username = "";
           this.dob = "";
           this.gender = "";
           this.cityname = "";
           this.suburb = "";
           this.stateid = "";

    },
    validate() {
      if (this.$refs.form.validate()) {
        this.register();
      }
    },
    register() {
    var getdob = "";
    getdob  = require("moment")(this.dob).format("YYYY-MM-DD");
      this.$store
        .dispatch("register", {
          firstname: this.firstname,
        //  lastname: this.lastname,
          email: this.email,
          password: this.password,
          region: this.region,
          username : this.username,
          dob : getdob,
          gender : this.gender,
          cityname : this.cityname,
          suburb: this.suburb,
          stateid: this.stateid
        })
        .then(response => {
          console.log(response);
          //this.$router.push({ name: "register" });
           this.$store
            .dispatch("retrieveUserDetails")
            .then(() => { 
              this.$router.push({ name: "home" });
            });

            // this.$router.go();
        })
        .catch(error => {
          // TODO: handle incorrect login
          console.log("logging error from register");
          console.log(error);
         // alert(error["status"]);
        // if(error.status =="error")
        // { 
         //  this.error = true;
         //  this.errorText = error.message;
        // }  
        });   
    },
    getRegions(){
      this.$store.dispatch("retriveRegions").then(() => {
           this.regions = this.$store.getters.getregions;
      });
    },
    selectcities(stateid)
    {
    
       this.$store
        .dispatch("citieslist", {
          countryname: this.region,
          stateid: stateid,
        })
        .then(response => {
          this.cities = response.data;
          console.log(response.data);
        })
        .catch(error => {
          // TODO: handle incorrect login
          console.log("cities error from rigister");
          console.log(error);
        });
    },
      stateslist(getcountry)
    {
    
       this.$store
        .dispatch("stateslist", {
          countryname: getcountry,
        })
        .then(response => {
          this.statesarr = response.data;
          console.log(response.data);
        })
        .catch(error => {
          // TODO: handle incorrect login
          console.log("cities error from rigister");
          console.log(error);
        });
    },
     getAdserverWebsiteList() { 
      this.$store.dispatch("retrieveAdserverWebsitesList", {
        })
        .then(response => {
          this.websitelist = response;
         // console.log(this.websitelist);
      })
        .catch(error => {
          // TODO: handle incorrect login
          console.log("Website List error");
          console.log(error);
        });
    },
    
    
  }
};
</script>
<style scoped lang="css">
 @import "https://cdn.jsdelivr.net/npm/openplayerjs@latest/dist/openplayer.min.css";

</style>
<style >
.dobpicker input {
    font-size: 16px;
    display: block;
    width: 100%;
    box-sizing: border-box;
    padding: 5px;
    padding-right: 40px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border-radius: 4px;
    background: transparent;
    /*border: 1px solid #9e9e9e;
    box-shadow: 0 0.1em 0.3em rgb(0 0 0 / 5%);*/
    outline: 0;
}
.vdpHeadCellContent{
  font-size: 10px;
}
.text-justify{font-size:10px !important;margin-bottom:0px !important;}
.v-tab{color: #272727 !important;font-size: 20px !important;} 
.v-tab:before, .v-tabs-slider {
    background-color: #272727 !important;
}
.v-responsive__sizer{padding-bottom: 43.33% !important;}
</style>
<style scoped>
.row {
  margin-left: 0px;
}
</style>